export const reviewAndViewTermsCopy = {
  step: 'Step 4 of 4',
  title: 'Review your information and complete sign up',
  description:
    'Your one step away from enrolling in our affordable energy program. Please check the information below is correct before continuing.',
  descriptionSponsoredSolar:
    'Please check that the information below is correct before continuing.',
  userDetailsEditableTab: {
    title: 'Your details',
    editTitle: 'Edit your details',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
  },
  proofDocEditabelTab: {
    title: 'Utility account',
    cardFront: 'Front',
    cardBack: 'Back',
  },
  submitButton: 'Sign up',
};
